import ConciliacaoAuttarConsultaScreen from "./ConciliacaoAuttarConsultaScreen";
import { EnumTrabalhoTipo } from "@/Models/Sistema/Trabalho/TrabalhoTipo";

export default function ConciliacaoGetNetLiquidaScreen() {
    return <ConciliacaoAuttarConsultaScreen codTrabalhoTipo={EnumTrabalhoTipo.GetNetLiquida} />;
}